import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as userActions from 'modules/user';

import { AdminUserDelete } from 'components';

class CtAdminUserDelete extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deleting: false
    };
  }

  removeUser = async () => {
    this.setState({ deleting: true });

    const { mountDeleteModal, userInfo: { userNo } } = this.props;

    const params = {};
    let isOk = true;
    if (userNo) {
      params.userNo = userNo;
    } else {
      // 오류
      isOk = false;
    }

    if (isOk) {
      try {
        const { UserActions } = this.props;
        await UserActions.deleteUser(params);
      } catch (e) {
        console.log(e);
      }
    } else {
      console.log('removeUser isOk fail!');
    }

    mountDeleteModal();
  };

  render() {
    const { deleting } = this.state;
    const { userInfo, mountDeleteModal } = this.props;
    const { removeUser, handleOnToggleDeleteModal } = this;

    return (
      <AdminUserDelete
        deleting={deleting}
        userInfo={userInfo}
        removeUser={removeUser}
        handleOnToggleDeleteModal={mountDeleteModal}
      />
    );
  }
}

CtAdminUserDelete.propTypes = {};
CtAdminUserDelete.defaultProps = {};

const mapDispatchToProps = dispatch => ({
  UserActions: bindActionCreators(userActions, dispatch)
});

export default connect(undefined, mapDispatchToProps)(CtAdminUserDelete);



// WEBPACK FOOTER //
// ./src/script/containers/admin/user/CtAdminUserDelete.js